import React, { useState, useEffect, useContext } from "react";
import axiosHttp from "../config/axios.interceptor";
import Loader from "../components/Loader";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import { AppContext } from "../contexts/AppContext";
import { errorResponseMessage } from "../shared/const.prop";

const Payments = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("paid");
  const [dashboardData, setDasboardData] = useState({});
  const [transactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);
  const [info, setInfo] = useState({
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
  });
  const [error, setError] = useState({});
  const { user } = useContext(AuthContext);
  const userName = user?.userName || user?.data?.data?.userName;

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
    fetchBankDetails();
  }, []);

  const fetchBankDetails = async () => {
    try {
      const getBankDetails = await axiosHttp.get("stripe/bank-account");
      if (getBankDetails.status === 200) {
        let data = getBankDetails?.data?.data;
        setInfo(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handleAccountChange = (e) => {
    const { name, value } = e.target;
    setError({ ...error, [name]: "" });
    setInfo({ ...info, [name]: value });
  };

  const formValidation = () => {
    let isValid = true;
    if (info.account_holder_name.trim().length < 3) {
      isValid = false;
      setError({ ...error, account_holder_name: "Enter minimum 3 characters" });
    } else if (info.account_number === "") {
      isValid = false;
      setError({ ...error, account_number: "Account number required" });
    } else if (info.ifsc_code === "") {
      isValid = false;
      setError({ ...error, ifsc_code: "IFSC required" });
    }
    if (isValid) {
      handleBankSubmit();
    } else {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Please fill the required fields",
      });
    }
  };

  const handleBankSubmit = async () => {
    setLoading(true);
    try {
      const addBankDetails = await axiosHttp.post("stripe/bank-account", info);
      if (addBankDetails.status === 201) {
        appContext.updateNotificationState({
          show: true,
          message: "Bank details updated successfully",
          type: "success",
        });
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  useEffect(() => {
    fetchTransactionData();
  }, [status]);

  const fetchPayment = async () => {
    try {
      const getPaymentData = await axiosHttp.get(`payment-balance`);
      if (getPaymentData.status === 200) {
        let data = getPaymentData?.data?.data;
        setDasboardData(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const fetchTransactionData = async () => {
    try {
      const getTransactionData = await axiosHttp.get(
        `appointments/payments?status=${status}`
      );
      if (getTransactionData.status === 200) {
        let data = getTransactionData?.data?.data;
        setTransactionData(data);
        fetchPayment();
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setTransactionData([]);
      fetchPayment();
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one-1  mb-5">
      <div className="card-body">
        <p className="title">
          <Link to={`../${userName}`} className="arrow mr-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M16.6667 10.2285C16.6667 10.5449 16.4316 10.8064 16.1266 10.8478L16.0417 10.8535L5.05508 10.853L9.02424 14.8059C9.26884 15.0495 9.26969 15.4452 9.02614 15.6898C8.80473 15.9122 8.45755 15.9331 8.21249 15.7521L8.14226 15.6917L3.10059 10.6717C3.06835 10.6396 3.04035 10.6049 3.01658 10.5682C3.00986 10.5571 3.00303 10.5458 2.99655 10.5343C2.99059 10.5244 2.98521 10.5142 2.98013 10.5038C2.97307 10.4887 2.96618 10.4731 2.95992 10.4572C2.95483 10.445 2.95059 10.433 2.94671 10.421C2.94211 10.4061 2.93764 10.3902 2.93379 10.3741C2.93093 10.3628 2.92866 10.352 2.92668 10.3411C2.9239 10.3249 2.92154 10.3081 2.91985 10.2912C2.91839 10.2782 2.91752 10.2654 2.91703 10.2526C2.91691 10.2448 2.91675 10.2367 2.91675 10.2285L2.91706 10.2043C2.91754 10.192 2.91838 10.1798 2.91958 10.1675L2.91675 10.2285C2.91675 10.1891 2.9204 10.1505 2.92739 10.1131C2.92901 10.1041 2.93094 10.095 2.93308 10.0858C2.93752 10.067 2.94265 10.0489 2.94855 10.0311C2.95146 10.0223 2.95483 10.0129 2.95844 10.0035C2.96575 9.98471 2.97369 9.96678 2.98242 9.94932C2.98648 9.94111 2.99102 9.93251 2.99578 9.924C3.00359 9.91012 3.01163 9.89693 3.02014 9.88407C3.02614 9.87497 3.03279 9.8655 3.03973 9.85617L3.04514 9.84897C3.06198 9.82697 3.08025 9.80612 3.09981 9.78657L3.10056 9.78599L8.14222 4.76515C8.3868 4.52158 8.78253 4.5224 9.0261 4.76698C9.24753 4.98933 9.26699 5.33659 9.08493 5.58089L9.02427 5.65086L5.05675 9.60301L16.0417 9.60351C16.3869 9.60351 16.6667 9.88333 16.6667 10.2285Z"
                fill="black"
                fill-opacity="0.6"
              />
            </svg>
          </Link>
          Payments
        </p>

        <div className="row mt-4">
          <div className="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
            <div className="payment-box text-center">
              <div className="card-body">
                <p className="mb-0 mt-3">Received amount</p>
                <p className="mb-3">{dashboardData?.balance || 0}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
            <div className="payment-box text-center">
              <div className="card-body">
                <p className="mb-0 mt-3">Pending amount</p>
                <p className="mb-3">{dashboardData?.pendingAmount || 0}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
            <div className="payment-box text-center">
              <div className="card-body">
                <p className="mb-0 mt-3">Life time earning</p>
                <p className="mb-3">{dashboardData?.liftimeEarning || 0}</p>
              </div>
            </div>
          </div>
        </div>
        <p className="mt-5 title">Transaction</p>

        <nav className="mt-4">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className={
                status === "paid"
                  ? "btn nav-item nav-link tab-btn-acc active "
                  : "btn nav-item tab-btn-acc nav-link"
              }
              onClick={() => setStatus("paid")}
            >
              All Transactions
            </button>

            {/* <button
              className={
                status === "withdraw"
                  ? "btn nav-item tab-btn-acc nav-link active"
                  : "btn nav-item tab-btn-acc nav-link"
              }
              onClick={() => setStatus("withdraw")}
            >
              Withdrawals
            </button> */}
            <button
              className={
                status === "account"
                  ? "btn nav-item nav-link tab-btn-acc active"
                  : "btn nav-item tab-btn-acc nav-link"
              }
              onClick={() => setStatus("account")}
            >
              Bank Account
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className={
              status === "paid" ? "tab-pane fade show active" : "tab-pane fade "
            }
            id="nav-contact"
            role="tabpanel"
            aria-labelledby="nav-contact-tab"
          >
            <div className=" mt-5 mb-4">
              <div className="card mt-5 mb-4">
                <div className="table-responsive">
                  <table className="table">
                    <thead className="table-col">
                      <tr>
                        <th className="text-nowrap">Service Name</th>
                        <th className="text-nowrap">Expertise</th>
                        <th className="text-nowrap">Mentor Name</th>
                        <th className="text-nowrap">Price</th>
                        <th className="text-nowrap">Start Date</th>
                        <th className="text-nowrap">End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactionData.map((item, index) => {
                        return (
                          <tr key={index}>
                            <th className="text-nowrap">
                              {item?.service_name || "-"}
                            </th>
                            <th className="text-nowrap">
                              {item?.expertise || "-"}
                            </th>
                            <th className="text-nowrap">
                              {item?.mentor_name || "-"}
                            </th>
                            <th className="text-nowrap">
                              {item?.net_price || "-"}
                            </th>
                            <th className="text-nowrap">
                              {(item?.start_time &&
                                moment(item?.start_time).format(
                                  "DD MMM, YYYY"
                                )) ||
                                "-"}
                            </th>
                            <th className="text-nowrap">
                              {(item?.end_time &&
                                moment(item?.end_time).format(
                                  "DD MMM, YYYY"
                                )) ||
                                "-"}
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              status === "withdraw"
                ? "tab-pane fade show active"
                : "tab-pane fade "
            }
            id="nav-contact"
            role="tabpanel"
            aria-labelledby="nav-contact-tab"
          >
            <div className="card mt-5 mb-4 ">
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-col">
                    <tr>
                      <th className="text-nowrap">Service Name</th>
                      <th className="text-nowrap">Expertise</th>
                      <th className="text-nowrap">Mentor Name</th>
                      <th className="text-nowrap">Price</th>
                      <th className="text-nowrap">Start Date</th>
                      <th className="text-nowrap">End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionData.map((item, index) => {
                      return (
                        <tr key={index}>
                          <th className="text-nowrap">
                            {item?.service_name || "-"}
                          </th>
                          <th className="text-nowrap">
                            {item?.expertise || "-"}
                          </th>
                          <th className="text-nowrap">
                            {item?.mentor_name || "-"}
                          </th>
                          <th className="text-nowrap">
                            {item?.net_price || "-"}
                          </th>
                          <th className="text-nowrap">
                            {(item?.start_time &&
                              moment(item?.start_time).format(
                                "DD MMM, YYYY"
                              )) ||
                              "-"}
                          </th>
                          <th className="text-nowrap">
                            {(item?.end_time &&
                              moment(item?.end_time).format("DD MMM, YYYY")) ||
                              "-"}
                          </th>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className={
              status === "account"
                ? "tab-pane fade show active"
                : "tab-pane fade "
            }
            id="nav-contact"
            role="tabpanel"
            aria-labelledby="nav-contact-tab"
          >
            <div className="mt-5 mb-4 ">
              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label>Account Holder Name</label>
                    <div className="input-group flex-gp">
                      <input
                        className="form-control py-4"
                        type="text"
                        name="account_holder_name"
                        value={info?.account_holder_name || ""}
                        onChange={(e) => handleAccountChange(e)}
                      />
                    </div>
                    {error?.account_holder_name && (
                      <p className="field-error">
                        {error?.account_holder_name}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label>Account Number</label>
                    <div className="input-group flex-gp">
                      <input
                        className="form-control py-4"
                        type="number"
                        name="account_number"
                        value={info?.account_number || ""}
                        onChange={(e) => handleAccountChange(e)}
                      />
                    </div>
                    {error?.account_number && (
                      <p className="field-error">{error?.account_number}</p>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label>IFSC Code</label>
                    <div className="input-group flex-gp">
                      <input
                        className="form-control py-4"
                        type="text"
                        name="ifsc_code"
                        value={info?.ifsc_code || ""}
                        onChange={(e) => handleAccountChange(e)}
                      />
                    </div>
                  </div>
                  {error?.ifsc_code && (
                    <p className="field-error">{error?.ifsc_code}</p>
                  )}
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary prim-btn"
                    onClick={formValidation}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;
